<template>
  <AppModal ref="modal" :stacked="true" @close="$emit('close')" @clickaway="close">
    <template slot="modal-header">
      <h3 class="font-weight-medium">
        Add Workflow Email
      </h3>
    </template>
    <template slot="modal-body">
      <AppLoading v-if="isLoading" class="h-50 p-4" />
      <form v-else class="form">
        <div class="mb-3">
          <label>Workflow</label>
          <Multiselect
            v-model="email.approvalWorkflowId"
            placeholder="Select Workflow"
            :options="workflowIdsByProduct"
            :customLabel="approvalCustomLabel"
            :multiple="false"
            :searchable="false"
          />
        </div>
        <div class="mb-3">
          <label>Action</label>
          <Multiselect
            v-model="email.action"
            placeholder="Select Workflow Action"
            :options="workflowActions"
            :customLabel="decamelize"
            :multiple="false"
            :searchable="false"
          />
        </div>
        <div class="mb-3">
          <label>Template</label>
          <Multiselect
            v-model="email.emailTemplateId"
            placeholder="Select Email template"
            :options="emailTemplateOptions"
            :customLabel="emailCustomLabel"
            :multiple="false"
            :searchable="false"
          />
        </div>
      </form>
    </template>
    <template slot="modal-footer">
      <AppButton class="btn btn-dark" @click="close">Cancel</AppButton>
      <AppButton class="btn btn-primary btn-raised" @click="add">
        Add
      </AppButton>
    </template>
  </AppModal>
</template>

<script>
import Multiselect from '@/components/Multiselect'
import { mapGetters, mapState } from 'vuex'
import useWorkflows from '@/components/composables/useWorkflows'

export default {
  components: {
    Multiselect,
  },
  props: {
    workflowActions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data () {
    return {
      isLoading: false,
      email: {
        approvalWorkflowId: null,
        action: null,
        emailTemplateId: null,
        id: null,
      },
    }
  },
  setup () {
    const { workflowIdsByProduct } = useWorkflows({ product: 'cm' })

    return {
      workflowIdsByProduct,
    }
  },
  computed: {
    ...mapGetters([ 'approvalWorkflows', 'approvalWorkflow' ]),
    ...mapState('curriculumEmails', [ 'templates' ]),
    emailTemplateOptions () {
      return this.templates.map(template => template.id)
    },
  },
  methods: {
    approvalCustomLabel (id) {
      const workflow = this.approvalWorkflow(id)
      return workflow ? workflow.name : 'Workflow Not Found'
    },
    emailCustomLabel (id) {
      const index = this.templates.findIndex(t => t.id === id)
      return this.templates[index].subject
    },
    close () {
      this.$refs.modal.close()
    },
    add () {
      this.isLoading = true
      setTimeout(() => {
        this.email.id = this.generateToken(5)
        this.$emit('add', this.email)
        this.close()
        this.isLoading = false
      }, 1000)
    },
  },
}
</script>

<style scoped>
.modal-backdrop >>> .modal-body {
  overflow: unset;
  max-height: 100%;
}
</style>
